import { lazy } from 'react';

import { LayoutType, PageType } from '@shared/constants/constants';
import {
  APPOINTMENT_ACCOMPANYING_VISITOR_ADDING_PATH,
  APPOINTMENT_ACCOMPANYING_VISITORS_PATH,
  APPOINTMENT_PATH,
} from '@shared/constants/paths';
import { SERVICE_CATALOG_CODE } from '@shared/constants/serviceCatalog';
import type { RouteConfig } from '@shared/types/common.types';

const AccompanyingVisitorsPage = lazy(() => import('./pages/AccompanyingVisitorsPage'));
const AccompanyingVisitorAddingPage = lazy(() => import('./pages/AccompanyingVisitorAddingPage'));

export const APPOINTMENT_ACCOMPANYING_VISITOR_ROUTES: RouteConfig[] = [
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    backUrl: APPOINTMENT_PATH,
    component: () => <AccompanyingVisitorsPage />,
    displayTitle: () => 'Accompanying Visitor(s)',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_ACCOMPANYING_VISITORS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    backUrl: APPOINTMENT_PATH,
    component: () => <AccompanyingVisitorAddingPage />,
    displayTitle: () => 'Add Accompanying Visitor',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_ACCOMPANYING_VISITOR_ADDING_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
  },
];
